import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash-es';

import { messages } from './messages';
import * as OrderActions from '../../store/orders/orders.actions';
import { BulkActionDataType } from '../../enums/bulk-action-data-type';

const getFulfillmentPlanCount = (job) => get(job, 'jobData.fulfillmentPlanCount', 0);

export const fulfillmentPlan = {
  id: BulkActionDataType.FULFILLMENT_PLAN,
  getBulkApplyMessageCount: getFulfillmentPlanCount,

  bulkApplyMessage: (count) => (
    <FormattedMessage
      {...messages.bulkApplyMessageShipments}
      values={{
        numberOfShipments: count,
        boldNumberOfShipments: <b>{count}</b>,
      }}
    />
  ),

  requestFilter: (fulfillmentPlanIds) => [{ fulfillmentPlanId: fulfillmentPlanIds }],

  startUpdateNotificationContent: (job) => {
    const fulfillmentPlanCount = getFulfillmentPlanCount(job);
    return (
      <FormattedMessage
        {...messages.shipments}
        values={{
          numberOfShipments: fulfillmentPlanCount,
        }}
      />
    );
  },

  updateSuccessNotificationContent: (job) => {
    const fulfillmentPlanCount = getFulfillmentPlanCount(job);
    return (
      <FormattedMessage
        {...messages.shipmentsSuccess}
        values={{
          numberOfShipments: fulfillmentPlanCount,
        }}
      />
    );
  },

  updateSuccessActions: () => [OrderActions.silentRequestGetOrders()],
};
